/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../Translate';

import {FetchAssetById} from '../../../actions/asset/action-asset';
import {RemoveBookmark} from '../../../actions/common/actions-common';
import {toHumanTime} from '../../../utils';

import _get from 'lodash/get';

class BookmarkMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnterTop = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveTop = {
      translateY: '-100px',
      opacity: 0
    };

    this.animationEnterBottom = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveBottom = {
      translateY: '100px',
      opacity: 0
    };

    this.state = {
      assetPoster: `/images/${Config.white_skin ? 'white' : 'black'}/white-full.png`,
      isShown: false
    };
  }

  componentWillMount() {
    this.props.FetchAssetById(_get(this.props, 'message.asset_id'), 'movie');

  }

  componentDidMount() {

    this.setState({
      isShown: this.props.isShown
    });

    this._getMetadata();
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      isShown: newProps.isShown
    });

    this._getMetadata(newProps);
  }

  _getMetadata(props = this.props) {

    if (props.asset.id) {

      lh.models.asset.methods.getPosterUrl(props.asset, {
        crop: {x: 218, y: 218},
        cache: false
      })
        .then((url) => {

          this.setState({
            assetPoster: url
          });
        }, ()=> {

          this.setState({
            assetPoster: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`
          });
        });
    }
  }

  _onContinueClick() {

    this.setState({
      isShown: false
    });

    this.props.RemoveBookmark(_get(this.props, 'message.asset_id'));
    this.props.message.onContinue && this.props.message.onContinue();

    this.props.onClose();
  }

  _onStartOverClick() {

    this.setState({
      isShown: false
    });

    this.props.RemoveBookmark(_get(this.props, 'message.asset_id'));
    this.props.message.onStartOver && this.props.message.onStartOver();

    this.props.onClose();
  }

  _onCrossClick() {

    this.setState({
      isShown: false
    });

    this.props.onClose();
  }

  _getTime() {

    return toHumanTime(_get(this.props, 'asset.bookmark'));
  }

  render() {

    return (
      <div>
        {this.state.isShown && <a className="mw-close ico ico-close slider-resume" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}></a>}
        {this.state.isShown && <div>
          <div className="popup-block bookmark">
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterTop, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveTop, easing: 'ease-in-out', duration: 150}}>
              <div className="img-container">
                <img className="bookmark-img" src={`/images/${Config.white_skin ? 'white' : 'black'}/playback.png`} />
                <img className="asset-img" src={this.state.assetPoster} />
              </div>
            </VelocityTransitionGroup>
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterBottom, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveBottom, easing: 'ease-in-out', duration: 150}}>
              <div>
                <p>
                  <strong> <Translate content="messages.bookmark.title" /> </strong>
                  <div className="pt">
                    <em style={{fontWeight: 'bold'}}> {_get(this.props, 'asset.title')} </em>
                  </div>
                </p>
              </div>
              <div className="mt+ message-actions">
                <a className="btn-dark-popup yes" href="javascript:void(0)" onClick={this._onContinueClick.bind(this)}> <Translate content="messages.bookmark.continue_from" /> {this._getTime()}</a>
                <a className="btn-dark-popup no" href="javascript:void(0)" onClick={this._onStartOverClick.bind(this)}> <Translate content="messages.bookmark.start_over" /> </a>
              </div>
            </VelocityTransitionGroup>
          </div>
        </div>}
      </div>
    );
  }
}

BookmarkMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    asset_id: PropTypes.number.isRequired,
    onContinue: PropTypes.func,
    onStartOver: PropTypes.func
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = ({assets}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'message.asset_id'), {});

  return {
    asset: asset
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById, RemoveBookmark}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Bookmark/bookmark-message.js